import { Translate } from '../../../shared/LanguageService';
import * as React from 'react';
import { ISpecialAuthorization } from './Types';
import { Button, ButtonToolbar, Checkbox } from 'react-bootstrap';

interface ISpecialAuthorizationsListRowProps {
    item: ISpecialAuthorization;
    key: number;
    isAssignedChange: (item: ISpecialAuthorization) => void;
}

const SpecialAuthorizationsListRow = (props: ISpecialAuthorizationsListRowProps) => {
    return (
        <tr>
            <td colSpan={2}>
                <Checkbox
                    disabled={props.item.readOnly}
                    checked={props.item.isAssigned}
                    onChange={() => props.isAssignedChange(props.item)}
                >
                    <span>{Translate(props.item.translationKey)}</span>
                </Checkbox>
            </td>
        </tr>
    );
};

export default SpecialAuthorizationsListRow;
